module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-body"
  }, [_c('div', {
    staticClass: "c-body__title"
  }, [_c('h2', [_c('span', [_vm._v("GridCalc")]), _vm._v(" "), _c('button', {
    class: {
      '-active': _vm.showHelp
    },
    on: {
      "click": _vm.toggleHelp
    }
  }, [_c('c-icon', {
    attrs: {
      "name": 'question-circle'
    }
  })], 1)])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "c-body__inner"
  }, [_c('div', {
    staticClass: "e-section"
  }, [_c('div', {
    staticClass: "e-grid -triple -center"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "e-label-list"
  }, [_c('label', {
    staticClass: "e-label"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("合計幅:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.total),
      expression: "options.total"
    }],
    staticClass: "e-input-text -smallest -center",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "2048"
    },
    domProps: {
      "value": (_vm.options.total)
    },
    on: {
      "blur": _vm.calculate,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.options.total = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "e-label"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("カラム数:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.cols),
      expression: "options.cols"
    }],
    staticClass: "e-input-text -smallest -center",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "999"
    },
    domProps: {
      "value": (_vm.options.cols)
    },
    on: {
      "blur": _vm.calculate,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.options.cols = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('label', {
    staticClass: "e-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.end),
      expression: "options.end"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.options.end) ? _vm._i(_vm.options.end, null) > -1 : (_vm.options.end)
    },
    on: {
      "change": _vm.calculate,
      "__c": function($event) {
        var $$a = _vm.options.end,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.options.end = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.options.end = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.options.end = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("両端の余白を含めて計算する")])])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('button', {
    staticClass: "e-button -primary -full",
    on: {
      "click": _vm.calculate
    }
  }, [_vm._v("グリッド計算")])])])]), _vm._v(" "), _c('hr', {
    staticClass: "e-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "e-section"
  }, [_c('transition', {
    attrs: {
      "name": "slide-in"
    }
  }, [(_vm.results !== null && !_vm.results.length) ? _c('div', {
    staticClass: "c-error-list"
  }, [_c('ul', {
    staticClass: "c-error-list__list"
  }, [_c('li', {
    staticClass: "c-error-list__item"
  }, [_c('c-icon', {
    attrs: {
      "name": 'error'
    }
  }), _vm._v("\n\t\t\t\t\t\t\t該当する結果がありません\n\t\t\t\t\t\t")], 1)])]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-in"
    }
  }, [(_vm.results && _vm.results.length) ? _c('div', {
    staticClass: "c-gridcalc-result"
  }, [_c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("カラム幅")]), _vm._v(" "), _c('th', [_vm._v("溝幅")]), _vm._v(" "), _c('th', [_vm._v("プレビュー")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.results), function(r, i) {
    return _c('tr', {
      key: i
    }, [_c('td', [_vm._v(_vm._s(r.col))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(r.gutter))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "c-gridcalc-result__preview",
      class: {
        '-end': r.end
      }
    }, _vm._l((r.preview), function(col, j) {
      return _c('div', {
        key: j,
        staticClass: "c-gridcalc-result__preview-item",
        style: ({
          width: col + '%'
        })
      })
    }))])])
  }))])]) : _vm._e()])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-help"
  }, [_c('div', {
    staticClass: "c-help__inner"
  }, [_c('div', {
    staticClass: "e-section"
  }, [_c('p', [_vm._v("\n\t\t\t\t\tグリッドのカラム幅と溝を計算する計算機です。\n\t\t\t\t\t整数値の結果だけを出力します。"), _c('br'), _vm._v("\n\t\t\t\t\tプレビューはおおまかなイメージなので実寸ではありません。"), _c('br'), _vm._v(" "), _c('small', [_vm._v("[IMO] %で指定する気もするのでもうこれ要らない説。")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c2900b1","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/page/gridcalc.vue
// module id = 57
// module chunks = 0